export default "__VITE_ASSET__375f548c__"